<template>
  <div class="ManageCohorts">
    <div class="container-fluid padding-right-0Perc">
      <div class="row col-xs-12 col-sm-12 col-md-12 col-lg-12 margin-Top-3Perc margin-bottom-2Perc vertical-align">
		    <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
        </div>
        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 font-size-18px padding-left-0Perc padding-right-0Perc text-align-right">
          Group Course
        </div>
        <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 text-align-left padding-left-0Perc ">
          <div class="row">
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 padding-left-4Point8Perc padding-right-1Point7Perc">
              <select class="form-control" v-model="groupCourseObj">
                <option value='-1' disabled>Select</option>
                <option v-for="groupCourseObj in groupCourseList" v-bind:key="groupCourseObj.GroupCourseMasterId" v-bind:value="groupCourseObj">{{ groupCourseObj.GroupName }} :: {{groupCourseObj.CourseTitle}} {{groupCourseObj.CourseSubTitle !== null && groupCourseObj.CourseSubTitle.trim().length !== 0 ? '[' + groupCourseObj.CourseSubTitle + ']': ''}}</option>
              </select>                  
            </div>
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 padding-Left-0px text-align-center">  
              <button type="button" class="btn black-border custom-btn white-BG" @click="loadAssociateCohorts">Go</button>
            </div>
            <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
            </div>
          </div>
        </div>   
      </div> 
      <div class="row margin-left-0Point3Perc">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <Manage-Cohorts-Details v-bind:cohortList="cohortListValue" v-bind:selectedGroupCourseObj="selectedGroupCourseObj" v-if="showCohortList" @refreshCohortList="loadAssociateCohorts"></Manage-Cohorts-Details>
        </div>
      </div>
    </div>
    <!-- Show Spinner -->
    <div class="animationload" v-show="showSpinner">
      <div class="osahanloading"></div>
    </div>
    <loader></loader>
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>  
  </div>
</template>

<script>
import Loader from '@/components/dashboard/Loader'
import { constants } from '@/utils/constants'
import { groupCourseService } from '@/server-util/group-course-service'
import { cohortService } from '@/server-util/cohort-service'
import ManageCohortsDetails from '@/components/ManageCohortsDetails'
import AlertBox from '@/components/AlertOverlay'
export default {
  created: function () {
    this.getAllGroupCourses()
  },
  data: function () {
    return {
      showSpinner: false,
      showAlertDialog: false,
      errorMsg: '',
      groupCourseObj: -1,
      cohortList: [],
      showCohortList: false
    }
  },
  components: {
    'Manage-Cohorts-Details': ManageCohortsDetails,
    'alert-box': AlertBox,
    'loader': Loader
  },
  methods: {
    loadAssociateCohorts: function () {
      var storeObj = this.$store
      var _this = this
      if (this.groupCourseObj === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a group course to see it\'s associated cohort list.'
        return
      }
      if (
        this.groupCourseObj.GroupCourseMasterId !== -1 && this.groupCourseObj.GroupCourseMasterId !== ''
      ) {
        // _this.showSpinner = true
        _this.$store.state.isLoading = true
        cohortService
          .getCohortListUsingGroupCourse(
            storeObj.state.access_token,
            this.groupCourseObj.GroupCourseMasterId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.cohortList = responseObj.data
              // AK: Hide Spinner after recieving Cohort list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              if (responseObj.data.length === 0) {
                _this.errorMsg = 'No cohort found in "' + this.groupCourseObj.GroupName + ' :: ' + this.groupCourseObj.CourseTitle + '".'
                _this.showAlertDialog = true
              } else {
                _this.showCohortList = true
              }
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // AK: Hide Spinner after recieving Cohort list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner after recieving Cohort list
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a group course to see it\'s associated cohort(s).'
      }
    },
    getAllGroupCourses: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined || storeObj.state.access_token !== ''
      ) {
        // AK: If group courses are not available then only show spinner
        if (storeObj.state.groupCourseList.length === 0) {
          // _this.showSpinner = true
          _this.$store.state.isLoading = true
        }
        groupCourseService
          .getGroupCourseList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.groupCourseList = responseObj.data
              if (this.$store.state.isLoading === true) {
                // AK: Hide Spinner after recieving Group Course list
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              if (this.$store.state.isLoading === true) {
                // AK: Hide Spinner after recieving Group Course list
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            }
          }, errorObj => {
            if (this.$store.state.isLoading === true) {
              // AK: Hide Spinner after recieving Group Course list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            }
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined GROUP COURSE LISTING OPERATION'
        )
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    }
  },
  computed: {
    groupCourseList: {
      get: function () {
        return this.$store.state.groupCourseList
      }
    },
    cohortListValue: {
      get: function () {
        return this.cohortList
      }
    },
    selectedGroupCourseObj: {
      get: function () {
        return this.groupCourseObj
      }
    }
  },
  name: 'ManageCohorts'
}
</script>

<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.ManageCohorts {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.font-size-18px
{
  font-size:18px;
}
.margin-Top-1Perc {
  margin-top: 1%;
}
.black-border {
  border: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px !important;
}
.padding-Left-30px {
  padding-left: 3% !important;
}
.white-BG {
  background-color: #ffffff;
}
.padding-Left-0px {
  padding-left: 0px !important;
}
.padding-right-0px {
  padding-right: 0px !important;
}
.margin-Top-3Perc{
  margin-top: 3% !important;
}
.border-red{
  border: 1px solid red;
}
.padding-right-0Perc{
  padding-right:0%;
}
.padding-left-0Perc{
  padding-left:0%;
}
.margin-left-1Perc{
  margin-left:1%;
}
margin-left-0Point3Perc{
  margin-left: 0.3%;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.padding-left-2Point8Perc{
  padding-left:2.8%;
}
.padding-left-4Point8Perc{
  padding-left:4.8%;
}
.padding-right-1Point7Perc{
  padding-right:1.7%;
}
.text-align-right{
  text-align:right; 
}
</style>



// WEBPACK FOOTER //
// src/components/ManageCohorts.vue